// extracted by mini-css-extract-plugin
module.exports = {"icon":"LoginIcon_icon__mXhgk","invertIcon":"LoginIcon_invertIcon__p7pY_","white":"LoginIcon_white__lkHp2"};